"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TokenBalance = /** @class */ (function () {
    function TokenBalance() {
    }
    return TokenBalance;
}());
exports.TokenBalance = TokenBalance;
//# sourceMappingURL=TokenBalance.js.map